import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const DashboardNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="border-b border-white/10 bg-black/70 backdrop-blur-lg sticky top-0 z-30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between">
        {/* Logo */}
        <button
          type="button"
          onClick={() => navigate('/')}
          className="flex items-center space-x-2 focus:outline-none"
        >
          <div className="w-8 h-8 bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg flex items-center justify-center">
            <span className="text-white font-bold text-sm">GO</span>
          </div>
          <span className="text-xl font-bold text-white">GameOS [BETA]</span>
        </button>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-6">
          <Link to="/dashboard" className="text-sm text-gray-300 hover:text-white">
            Dashboard
          </Link>
          <Link to="/create" className="text-sm text-gray-300 hover:text-white">
            Create
          </Link>
          <Link to="/pricing" className="text-sm text-gray-300 hover:text-white">
            Pricing
          </Link>
          <Link to="/help" className="text-sm text-gray-300 hover:text-white">
            Help
          </Link>
          <a
            href="https://x.com/GameOSdev"
            target="_blank"
            rel="noreferrer"
            className="text-sm text-gray-400 hover:text-white"
          >
            X
          </a>
          <a
            href="https://t.me/tokenos_ai"
            target="_blank"
            rel="noreferrer"
            className="text-sm text-gray-400 hover:text-white"
          >
            Telegram
          </a>
          {user && (
            <div className="flex items-center gap-3">
              <span className="text-xs px-3 py-1 rounded-full border border-purple-500/50 bg-purple-900/40 text-purple-100">
                Credits: <span className="font-semibold">{user.credits ?? '∞'}</span>
              </span>
              <span className="text-xs px-3 py-1 rounded-full border border-emerald-500/50 bg-emerald-900/40 text-emerald-100">
                Plan: <span className="font-semibold">{user.subscription === 'pro' && user.subscription_status === 'active' ? 'Pro' : 'Free'}</span>
              </span>
              <span className="text-sm text-gray-400">
                Hi, {user.username}
              </span>
            </div>
          )}
          <Button
            variant="outline"
            onClick={handleLogout}
            className="border-red-500 text-red-400 hover:bg-red-500/10 text-sm"
          >
            Logout
          </Button>
        </div>

        {/* Mobile menu button */}
        <button
          type="button"
          className="md:hidden text-gray-300 hover:text-white"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <div className="md:hidden border-t border-white/10 bg-black/95">
          <div className="px-4 py-3 space-y-2">
            <Link
              to="/dashboard"
              className="block text-sm text-gray-300 hover:text-white"
              onClick={() => setIsOpen(false)}
            >
              Dashboard
            </Link>
            <Link
              to="/create"
              className="block text-sm text-gray-300 hover:text-white"
              onClick={() => setIsOpen(false)}
            >
              Create
            </Link>
            <Link
              to="/pricing"
              className="block text-sm text-gray-300 hover:text-white"
              onClick={() => setIsOpen(false)}
            >
              Pricing
            </Link>
            <Link
              to="/help"
              className="block text-sm text-gray-300 hover:text-white"
              onClick={() => setIsOpen(false)}
            >
              Help
            </Link>
            <a
              href="https://x.com/GameOSdev"
              target="_blank"
              rel="noreferrer"
              className="block text-sm text-gray-400 hover:text-white"
            >
              X
            </a>
            <a
              href="https://t.me/tokenos_ai"
              target="_blank"
              rel="noreferrer"
              className="block text-sm text-gray-400 hover:text-white"
            >
              Telegram
            </a>
            {user && (
              <div className="flex flex-col gap-2 pt-2">
                <span className="text-xs px-3 py-1 rounded-full border border-purple-500/50 bg-purple-900/40 text-purple-100 w-max">
                  Credits: <span className="font-semibold">{user.credits ?? '∞'}</span>
                </span>
                <span className="text-xs px-3 py-1 rounded-full border border-emerald-500/50 bg-emerald-900/40 text-emerald-100 w-max">
                  Plan: <span className="font-semibold">{user.subscription === 'pro' && user.subscription_status === 'active' ? 'Pro' : 'Free'}</span>
                </span>
                <span className="text-sm text-gray-400">
                  Hi, {user.username}
                </span>
              </div>
            )}
            <div className="flex justify-end pt-2">
              <Button
                variant="outline"
                onClick={() => {
                  setIsOpen(false);
                  handleLogout();
                }}
                className="border-red-500 text-red-400 hover:bg-red-500/10 text-xs"
              >
                Logout
              </Button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default DashboardNavbar;
